import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import AdxModuleDashboardGrid from 'components/reusable/grids/AdxModuleDashboardGrid'
import AdxActionButton from 'components/reusable/ActionButton/AdxActionButton'
import LeaveBalanceCard from './leaveBalanceCard'
import LeaveRequestCard from './leaveRequestCard'
import { Grid } from '@mui/material'

const MyRequest = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state

  const handleCreateNewRequest = () => {
    navigate('/app/leave/request/create', {
      state: {
        backgroundLocation: location,
      },
    })
  }

  //To open leave request detail drawer if navigate from dashboard.
  //To refactor this by creating an independent page for leave request detail.
  useEffect(() => {
    let mounted = true
    if (mounted) {
      if (state?.from === 'dashboard') {
        return navigate(
          state?.leave_type === 'Leave credit'
            ? `/app/leave/leave_credit/${state?.id}`
            : `/app/leave/request/${state?.id}`,
          {
            state: {
              backgroundLocation: location,
              from: 'dashboard',
            },
          }
        )
      }
    }
    return () => {
      mounted = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <DashboardContainer headerTitle="My Request">
      <Grid container spacing={2}>
        <Grid item xs={12} md={7} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <AdxActionButton
            icon="calendar_today"
            iconColor="alternate.main"
            iconBgColor="alternate.light"
            title="Request for Leave"
            description={null}
            actionMessage="Request"
            icon2="chevron_right"
            onClick={handleCreateNewRequest}
            divClick
            sx={{
              borderRadius: '4.5px',
              border: '1px solid #e5e5e5',
            }}
          />
          <Box sx={{ height: '100%' }}>
            <Typography variant="h4" fontWeight="bold" color="dark-text.main">
              My Leave Request
            </Typography>
            <Box
              sx={{
                width: '100%',
                height: 'calc(100% - 40px)',
                mt: 2,
              }}
            >
              <LeaveRequestCard />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={5}>
          <LeaveBalanceCard />
        </Grid>
      </Grid>
    </DashboardContainer>
  )
}

export default MyRequest
